export default __webpack_public_path__ + "static/media/LambdaEatsLogo.43bcc30d.png";